const Queston_Answer = [
    {
      question: 'What is Coke® Festive Promotion?',
      answer: 'Coke® Festive Promotion  is an online promotion activity where on purchase of two Coca-Cola® promotion  packs of 1L, consumers can participate to win Rs.50 Amazon Pay Gift Card!',
    },
    {
      question: 'What is the promotion duration timings?',
      answer: 'This Promotion will commence at 00:00:01 am Indian Standard Time (“IST”) on1 st September 2024(“Start Date”) and will continue until 2nd November 2024 at 11:59:59 pm IST (“End Date”). However, Prize(s) will be open every day during these dates between 12:00:00 pm IST and 10:00:00 pm IST only (“Daily Prize Window”). Any entries received outside the Promotion Period shall not be eligible for the Prize(s) and shall not be carried forward to any other promotional scheme ahead.',
    },
    {
      question: 'On which product is this promo applicable?',
      answer: 'The offer is applicable on purchase of promotional 1L packs of Coca-Cola® brand only.',
    },
    {
      question: ' How do I participate?',
      answer: "Here's how to participate: 1. Grab two (2) Coke® promotion* packs 2. Scan the QR code to sign-up with the Coke® WhatsApp channel and continue participating by interacting with the channel. 3. Enter the Unique Code from behind the label of the first bottle, follow the same step with the 2 nd bottle 4. Your Rs.50 Amazon Pay Gift Card is unlocked as soon as you enter the two unique codes! Please note: You can only participate during the hours of 12PM - 10PM!",
    },
    {
      question: 'Why do I need to sign-up?',
      answer: 'We need you to sign up so we can verify your participation eligibility, disburse your prizes, and notify you when you win.',
    },
    {
      question: 'What is a unique code?',
      answer: 'A unique code is a 10-character alphanumeric code printed behind the label of Coke® Promotion product. It can be used to participate in the Promotion to win Rs. 50 Amazon Pay Gift Cards.',
    },
    {
      question: 'Can I participate without the unique code?',
      answer: 'No, you cannot participate in this Promotion without a unique code.',
    },
    {
      question: 'What are the prizes available to be won?',
      answer: 'Winners will receive a Rs.50 Amazon Pay Gift card on submitting 2 Unique codes.',
    },
    {
      question: 'How many times can a player win during this promo?',
      answer: 'The Rs.50 Amazon Pay Gift card can only be won twice by each mobile number during the entire promotion period.',
    },
    {
      question: 'Where can I check the status of my reward?',
      answer: 'All your prizes will be visible by selecting the ‘My Wins’',
    },
    {
      question: 'How can I redeem my Reward?',
      answer: 'If you are one of the winners of the Amazon Pay Gift Card, you will be notified instantly on the Coke® Festive WhatsApp Chat Bot. The code of you Amazon Pay gift card will be available to you on the Coke Coke® Festive WhatApp Chat Bot when you click on ‘My Win’. You can add your 14-digit code Gift Card to your Amazon Pay balance by visiting www.amazon.in/addgiftcard and add the Gift Card balance in your Amazon.in account. You can add multiple Gift Cards to the same account.',
    },
    {
      question: 'I tried using the unique code, but it shows that it has been used. What should I do?',
      answer: 'Each unique code printed behind the label of a Coke® Festive promotion product can only be used once on the promotion website. If you want to participate again, you must use a new unique code. If you are still facing issues, please get in touch with us at indiahelpline@coca-cola.com or call us at 1800-208-2653 (Timings: 09:00am - 09:00pm Mon-Sat, 09:00am - 06:00pm Sun).',
    },
    {
      question: 'I entered two valid unique codes, but it shows the hourly quota is over. What should I do?',
      answer: 'We have a set number of rewards per hour. if you have missed winning, do not worry try again later between 12PM-10PM IST with 2 new unique codes.',
    },
    {
      question: 'What is the validity of the Amazon Pay Gift Card?',
      answer: 'The validity of the Amazon Pay Gift Card is for15 th Oct 2024 .',
    },
    {
      question: 'I have more questions.',
      answer: 'If you are still facing issues, please get in touch with us at indiahelpline@coca-cola.com or call us at 1800-208-2653 (Timings: 09:00am - 09:00pm Mon - Sat, 09:00am - 06:00pm Sun).',
    },
  ];

export default Queston_Answer;